import { CurrencyServiceMock } from "./currency.types";

export const mockCurrencyService = (): CurrencyServiceMock => ({
  fetchCurrencies: jest.fn(),
});
